import { useMutation } from '@tanstack/react-query'
import { postAddCustomerWalletV2 } from 'services/CustomerService'
import type { AddCustomerWalletRequestV2, WalletResponse } from 'types/customers'

export const useAddCustomerWalletRequest = () => {
  return useMutation({
    mutationFn: (wallet: AddCustomerWalletRequestV2): Promise<WalletResponse> =>
      postAddCustomerWalletV2(wallet),
  })
}
